export enum MatchHistoryType {    
    MatchOffer = 1,
    CrossMatch = 2
}